// import React, { useState, useEffect } from "react";
// import Table from "@mui/material/Table";
// import TableBody from "@mui/material/TableBody";
// import TableCell from "@mui/material/TableCell";
// import TableContainer from "@mui/material/TableContainer";
// import TableHead from "@mui/material/TableHead";
// import TableRow from "@mui/material/TableRow";
// import Paper from "@mui/material/Paper";
// import "../components/Table/Table.css";
// import { useNavigate } from "react-router";
// import { useTranslation } from "react-i18next";
// import TopLoader from "../components/Loader/TopLoader";
// import { getRejectedRequirements, getRequirements } from "../api/Users";
// import { toast } from "react-toastify";
// import { TextField, TablePagination } from "@mui/material";
// import SearchIcon from "@mui/icons-material/Search";
// import "react-responsive-modal/styles.css";
// import { Modal } from "react-responsive-modal";
// import axios from "../api/constant";

// const RejectedRequirements = ({ role, mainId }) => {
//   const { t } = useTranslation();

//   const [isLoading, setIsLoading] = useState(true);
//   const [rows, setRows] = useState([]);
//   const [open, setOpen] = useState(false);

//   // Search and pagination
//   const [modalOpen, setModalOpen] = useState(false);

//   const [filteredData, setFilteredData] = useState([]);
//   const [searchQuery, setSearchQuery] = useState("");
//   const [page, setPage] = useState(0);
//   const [rowsPerPage, setRowsPerPage] = useState(10);
//   const [selectedRow, setSelectedRow] = useState(null);
//   const [districtDropdown, setDistrictDropdown] = useState("all");
//   const [Alldistricts, setAllDistricts] = useState([]);

//   useEffect(() => {
//     setIsLoading(true);
//     axios
//       .get(`/rejected_req?district_code=${districtDropdown}`)
//       .then((response) => {
//         if (response.data.status == "success") {
//           setRows(response.data.data);
//           setFilteredData(response.data.data);
//           setIsLoading(false);
//         } else {
//           setRows([]);
//           toast.error(t("Something went wrong"));
//           setFilteredData([]);
//           setIsLoading(false);
//         }
//       })
//       .catch((error) => {
//         console.error("Error fetching districts:", error);
//       });
//   }, [districtDropdown]);

//   useEffect(() => {
//     // Call API to fetch districts when the component mounts
//     axios
//       .get("/get_all_districts")
//       .then((response) => {
//         console.log(response);
//         if (response.data.status == "success") {
//           setAllDistricts(response.data.data);
//         } else {
//           setAllDistricts([]);
//         }
//       })
//       .catch((error) => {
//         console.error("Error fetching districts:", error);
//       });
//   }, []);

//   // useEffect(() => {
//   //   getAllrequirements();
//   // }, []);

//   const onOpenModal = () => setOpen(true);
//   const closeModal = () => {
//     setOpen(false);
//   };
//   // Update filteredData whenever searchQuery changes
//   useEffect(() => {
//     const filtered = rows.filter(
//       (item) =>
//         (item?.requirement_name &&
//           item.requirement_name
//             .toLowerCase()
//             .includes(searchQuery.toLowerCase())) ||
//         (item?.hostel_id &&
//           item.hostel_id.toLowerCase().includes(searchQuery.toLowerCase()))
//     );

//     setFilteredData(filtered);
//     setPage(0);
//   }, [searchQuery, rows]);

//   const handleChangePage = (event, newPage) => {
//     setPage(newPage);
//   };

//   const handleChangeRowsPerPage = (event) => {
//     setRowsPerPage(parseInt(event.target.value, 10));
//     setPage(0);
//   };

//   let navigate = useNavigate();
//   const view = (id) => {
//     navigate(`/${role !== 5 ? "admin" : "dealer"}/admindetails/${id}`);
//   };

//   const handleSelectDistrict = async (e) => {
//     setDistrictDropdown(e.target.value);
//     // const hostelName = e.target.value;
//   };

//   return (
//     <>
//       <TopLoader loading={isLoading ? "50" : "100"} />
//       <div className="px-0 px-md-3">
//         <div
//           style={{
//             display: "flex",
//             flexDirection: "row",
//             justifyContent: "space-between",
//           }}
//         >
//           <h5 className="my-3">{t("Rejected Requirements")}</h5>
//           <div className="mb-3">
//             <TextField
//               label={t("Search")}
//               variant="outlined"
//               value={searchQuery}
//               onChange={(e) => setSearchQuery(e.target.value)}
//               InputProps={{
//                 endAdornment: <SearchIcon />,
//               }}
//               style={{
//                 width: "17rem",
//                 marginTop: "20px", // Additional style from your existing code
//               }}
//             />
//           </div>
//         </div>
//         {role == 8 || role == 11 || role == 12 || role == 13? (
//           <div
//             className=""
//             style={{ display: "flex", justifyContent: "space-between" }}
//           >
//             <div className="col-md-2" style={{ marginRight: "12px" }}>
//               <label htmlfor="title">{t("District")}</label>
//               <select
//                 name="district" // value={AssetsType}
//                 className="common-input form-select"
//                 onChange={handleSelectDistrict}
//               >
//                 <option value="all" selected={true}>
//                   {t("All")}
//                 </option>
//                 {Alldistricts &&
//                   Alldistricts.map((row) => (
//                     <option key={row.district_code} value={row.district_code}>
//                       {" "}
//                       {row.name}
//                     </option>
//                   ))}
//               </select>
//             </div>
//           </div>
//         ) : (
//           ""
//         )}
//         <div className="Table mb-6">
//           <TableContainer
//             component={Paper}
//             style={{ boxShadow: "0px 13px 20px 0px #80808029" }}
//             className="my-4"
//           >
//             <Table sx={{ minWidth: 650 }} aria-label="simple table">
//               <TableHead>
//                 <TableRow>
//                   <TableCell>{t("Sr. No.")}</TableCell>
//                   <TableCell align="left">{t("Requirement")}</TableCell>
//                   <TableCell align="left">{t("District")}</TableCell>
//                   <TableCell align="left">{t("Block")}</TableCell>
//                   <TableCell align="left">{t("School Name")}</TableCell>
//                   <TableCell align="center">{t("Proposed Quantity")}</TableCell>
//                   <TableCell align="center">{t("Rejected By")}</TableCell>
//                   <TableCell align="left">{t("Rejection Reason")}</TableCell>
//                 </TableRow>
//               </TableHead>
//               {!isLoading && filteredData && filteredData.length > 0 && (
//                 <TableBody style={{ color: "white" }}>
//                   {filteredData
//                     .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
//                     .map((row, index) => (
//                       <TableRow
//                         key={index}
//                         sx={{
//                           "&:last-child td, &:last-child th": { border: 0 },
//                         }}
//                       >
//                         <TableCell component="th" scope="row">
//                           {index + 1}
//                         </TableCell>
//                         <TableCell align="left">
//                           {row.requirement_name}{" "}
//                         </TableCell>
//                         <TableCell align="left">{row.district}</TableCell>
//                         <TableCell align="left">{row.block}</TableCell>
//                         <TableCell align="left">{row.school_name} </TableCell>
//                         <TableCell align="center">{row.old_quantity}</TableCell>
//                         <TableCell align="center">{row.quantity}</TableCell>
//                         <TableCell align="left">
//                           <span className="text-danger" onClick={onOpenModal}>
//                             {t("Rejected")}
//                           </span>
//                           <Modal open={open} onClose={closeModal} center>
//                             <h5>Reason for Rejection</h5>
//                             <textarea
//                               name="reason"
//                               cols="50"
//                               rows="10"
//                               placeholder="Reason for Rejection"
//                               value={row.remarks}
//                               style={{
//                                 width: "100%",
//                                 border: "1px solid #ccc", // Adding a border for visibility
//                                 resize: "vertical", // Allowing vertical resizing
//                               }}
//                               readOnly
//                             />
//                           </Modal>
//                         </TableCell>
//                       </TableRow>
//                     ))}
//                 </TableBody>
//               )}
//               {!isLoading && (!filteredData || filteredData.length === 0) && (
//                 <TableRow>
//                   <TableCell align="center" colSpan={7}>
//                     <h4>
//                       {" "}
//                       <i>{t("No data available")}</i>{" "}
//                     </h4>
//                   </TableCell>
//                 </TableRow>
//               )}
//             </Table>
//           </TableContainer>
//           <TablePagination
//             rowsPerPageOptions={[10, 25, 50]}
//             component="div"
//             count={filteredData.length}
//             rowsPerPage={rowsPerPage}
//             page={page}
//             onPageChange={handleChangePage}
//             onRowsPerPageChange={handleChangeRowsPerPage}
//           />
//         </div>
//       </div>
//     </>
//   );
// };

// export default RejectedRequirements;
import React, { useState, useEffect } from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { TextField, TablePagination } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { Modal } from "react-responsive-modal";
import axios from "../api/constant";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import TopLoader from "../components/Loader/TopLoader";
import { useNavigate } from "react-router";
import { Button, Typography } from "@mui/material";

const RejectedRequirements = ({ role, mainId }) => {
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(true);
  const [rows, setRows] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [districtDropdown, setDistrictDropdown] = useState("all");
  const [allDistricts, setAllDistricts] = useState([]);
  const [modalStates, setModalStates] = useState({});

  useEffect(() => {
    setIsLoading(true);
    axios
      .get(`/rejected_req?district_code=${districtDropdown}`)
      .then((response) => {
        if (response.data.status === "success") {
          setRows(response.data.data);
          setFilteredData(response.data.data);
          setIsLoading(false);
        } else {
          setRows([]);
          setFilteredData([]);
          setIsLoading(false);
          toast.error(t("Something went wrong"));
        }
      })
      .catch((error) => {
        console.error("Error fetching requirements:", error);
      });
  }, [districtDropdown, t]);

  useEffect(() => {
    axios
      .get("/get_all_districts")
      .then((response) => {
        if (response.data.status === "success") {
          setAllDistricts(response.data.data);
        } else {
          setAllDistricts([]);
        }
      })
      .catch((error) => {
        console.error("Error fetching districts:", error);
      });
  }, []);

  useEffect(() => {
    const initialModalStates = {};
    rows.forEach((row) => {
      initialModalStates[row.id] = false;
    });
    setModalStates(initialModalStates);
  }, [rows]);

  const toggleModal = (id) => {
    setModalStates((prevState) => ({
      ...prevState,
      [id]: !prevState[id],
    }));
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  let navigate = useNavigate();
  const view = (id) => {
    navigate(`/${role !== 5 ? "admin" : "dealer"}/admindetails/${id}`);
  };

  const handleSelectDistrict = (e) => {
    setDistrictDropdown(e.target.value);
  };

  const filteredRows = filteredData.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage
  );

  const getSerialNumber = (index) => {
    return page * rowsPerPage + index + 1;
  };

  return (
    <>
      <TopLoader loading={isLoading ? "50" : "100"} />
      <div className="px-0 px-md-3">
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
          }}
        >
          <h5 className="my-3">{t("Rejected Requirements")}</h5>
          <div className="mb-3">
            <TextField
              label={t("Search")}
              variant="outlined"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              InputProps={{
                endAdornment: <SearchIcon />,
              }}
              style={{
                width: "17rem",
                marginTop: "20px",
              }}
            />
          </div>
        </div>
        {role == 8 || role == 11 || role == 12 || role == 13&& (
          <div
            className=""
            style={{ display: "flex", justifyContent: "space-between" }}
          >
            <div className="col-md-2 mb-4" style={{ marginRight: "12px" }}>
              <label htmlFor="title">{t("District")}</label>
              <select
                name="district"
                className="common-input form-select"
                onChange={handleSelectDistrict}
                value={districtDropdown}
              >
                <option value="all">{t("All")}</option>
                {allDistricts.map((row) => (
                  <option key={row.district_code} value={row.district_code}>
                    {row.name}
                  </option>
                ))}
              </select>
            </div>
          </div>
        )}
        <div className="Table mb-6">
          <TableContainer component={Paper}>
            <Table aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell>{t("Sr. No.")}</TableCell>
                  <TableCell align="left">{t("Requirement")}</TableCell>
                  <TableCell align="left">{t("District")}</TableCell>
                  <TableCell align="left">{t("Block")}</TableCell>
                  <TableCell align="left">{t("School Name")}</TableCell>
                  <TableCell align="center">{t("Proposed Quantity")}</TableCell>
                  <TableCell align="center">{t("Rejected By")}</TableCell>
                  <TableCell align="left">{t("Rejection Reason")}</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {filteredRows.map((row, index) => (
                  <TableRow key={index}>
                    <TableCell>{getSerialNumber(index)}</TableCell>
                    <TableCell align="left">{row.requirement_name}</TableCell>
                    <TableCell align="left">{row.district}</TableCell>
                    <TableCell align="left">{row.block}</TableCell>
                    <TableCell align="left">{row.school_name}</TableCell>
                    <TableCell align="center">{row.old_quantity}</TableCell>
                    <TableCell align="center">{row.quantity}</TableCell>
                    <TableCell align="left">
                      <Typography
                        variant="button"
                        className="danger-btn btn btn-sm"
                        id="btn4"
                        style={{ margin: "8px" }}
                        onClick={() => toggleModal(row.id)}
                      >
                        {t("Rejected")}
                      </Typography>
                      <Modal
                        open={modalStates[row.id]}
                        onClose={() => toggleModal(row.id)}
                        center
                      >
                        <h5>{t("Reason for Rejection")}</h5>
                        {/* Replace textarea with a div or p element */}
                        <div
                          style={{
                            width: "25rem",
                            padding: "5px",
                            minHeight: "150px", // Adjust height as needed
                            overflowY: "auto", // Enable vertical scrolling if content exceeds height
                          }}
                        >
                          {row.remarks}
                        </div>
                      </Modal>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
          <TablePagination
            rowsPerPageOptions={[10, 25, 50]}
            component="div"
            count={filteredData.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </div>
      </div>
    </>
  );
};

export default RejectedRequirements;
